import React from 'react';
import { SEOHead } from '@/components/SEOHead';
import { changelog } from '@/data/changelog';

function formatDate(dateStr: string): string {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

const Changelog: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Changelog — Milky Way Planner"
        description="See what's new on Milky Way Planner. Updates and improvements to the visibility calendar, moon tools, and trip planner, listed by date."
        canonicalUrl="/changelog"
      />
      <div className="min-h-screen bg-background">
        <section className="bg-slate-950 py-16 sm:py-20">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
            <span className="eyebrow text-gold-light mb-4 block">What's new</span>
            <h1 className="text-3xl md:text-4xl text-white tracking-[-0.03em] mb-4">
              Changelog
            </h1>
            <p className="text-lg text-white/70 leading-relaxed max-w-2xl mx-auto">
              Updates and improvements to Milky Way Planner, most recent first.
            </p>
          </div>
        </section>

        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
          <div className="space-y-10">
            {changelog.map((entry) => (
              <div key={entry.date} className="flex gap-6 sm:gap-8">
                {/* Date column */}
                <div className="w-36 sm:w-44 shrink-0 pt-0.5">
                  <time
                    dateTime={entry.date}
                    className="text-sm font-medium text-muted-foreground"
                  >
                    {formatDate(entry.date)}
                  </time>
                </div>

                {/* Items column */}
                <div className="flex-1 border-l border-border pl-6 sm:pl-8">
                  <ul className="space-y-2">
                    {entry.items.map((item, i) => (
                      <li key={i} className="text-sm text-foreground leading-relaxed">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Changelog;
